import {
  FormTimesheetEntryContractor,
  ReadTimesheetEntryContractor,
} from "@/types/timesheetEntryContractor";
import { v4 as uuidv4 } from "uuid";
import { normalizeDatetimeForWrite } from "@/lib/utils/normalizeDatetimeForWrite";

export const convertReadTimesheetEntryContractorsToFormContractors = (
  item: ReadTimesheetEntryContractor,
): FormTimesheetEntryContractor => ({
  ...item,
  // The contracts consists of entries that have been already created and can be edited (id!=null)
  // and entries that are just a "template" (id=null) that can be used for creating a new contactor entry.
  // But we need something that will act as a key for react, hence we generate one here.
  id: uuidv4(),
  original_id: item.id,
  start_datetime:
    normalizeDatetimeForWrite(item.start_datetime?.toString()) ?? "",
  end_datetime: normalizeDatetimeForWrite(item.end_datetime?.toString()) ?? "",
  break_time: item.break_time?.toString() ?? "",
});
